module.exports = __webpack_public_path__ + "img/Differentiation-BRCA_10X_IDC.95b31332.png";